export default "__VITE_ASSET__OFlLwHEX__"